var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-cta"},[_c(_vm.Icon,{tag:"component",staticClass:"icon-cta__icon"}),_c('p',{staticClass:"icon-cta__text"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }